import PaymentButton from './PaymentButton';

export default PaymentButton;
